import { QueryFunctionContext } from "@tanstack/react-query";

import { API_LIMIT } from "../../utils/constants";
import { useInventoryApi } from "../../hooks";
import { InventoryApiListIntegrationRequest } from "../../api/v1";
import useListQuery from "../../utils/use-list-query";

const QUERY_KEY = "listIntegrations";

export default function useListIntegrations({
  limit,
  skip = 0,
  ...props
}: InventoryApiListIntegrationRequest) {
  const api = useInventoryApi();

  const fetchIntegrations = async ({
    pageParam = skip,
  }: QueryFunctionContext) =>
    api.listIntegration({
      ...props,
      limit: limit ?? API_LIMIT,
      skip: pageParam,
    });

  return useListQuery({
    fetchMethod: fetchIntegrations,
    queryKey: [QUERY_KEY, props],
  });
}
